export default function InvoiceHeader({ invoiceData, setInvoiceData }) {
  return (
    <section className="text-right space-y-6" aria-label="Invoice Details">   
      <fieldset className="flex flex-col space-y-2 sm:ml-3 justify-center">
      <div className="flex items-center justify-between">
        <label htmlFor="invoice-no" className="text-sm font-medium text-gray-600 w-20 text-left">Invoice No.</label>
          <input
          name="invoice-no"    
          id="invoice-no"
          type="text" 
          onChange={(e) => setInvoiceData({...invoiceData, invoiceNo: e.target.value})}
          value={invoiceData.invoiceNo}
          maxLength={20}
          className="w-24 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-center font-mono grow"
        />
      </div>
        <div className="flex items-center justify-between">
          <label htmlFor="issue-date" className="text-sm font-medium text-gray-600 w-20 text-left">Issue date</label>
          <input 
            name="issue-date"
            id="issue-date"
            type="date" 
            onChange={(e) => setInvoiceData({...invoiceData, issueDateValue: e.target.value})}
            value={invoiceData.issueDateValue}
            className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>
        <div className="flex items-center justify-between">
          <label htmlFor="due-date" className="text-sm font-medium text-gray-600 w-20 text-left">Due date</label>
          <input 
            id="due-date"
            name="due-date"
            type="date" 
            onChange={(e) => setInvoiceData({...invoiceData, dueDateValue: e.target.value})}
            value={invoiceData.dueDateValue}
            className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>
      </fieldset>
    </section>
  )
}
